export const dataCustomerIssue = [{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:true,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:true,
  csState:"Wait on 3rd party",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#3424234675-GBS",
  customerMessage:"I emailed to can... ",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"15.12:Kh dat 9 ornament...",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:true,
  csState:"Wait on customer",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS123123123453",
  orderName:"#342342342-GBS",
  customerMessage:"I emailed to can...",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:true,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009679",
  orderName:"#212702643-GB S",
  customerMessage:"When I ordered, ...",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:true,
  csState:"Pending",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Resolved",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Closed",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Closed",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Open",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Open",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Open",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Wait on customer",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Wait on customer",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},

{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"Wait on customer",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},{
  code:"CS20211221009685",
  orderName:"#212701560-GBS",
  customerMessage:"Order aparently abc def xyz",
  kind:"Pending",
  creatAt:"May 15 2020 08:00 pm",
  agentNote:"21.12:baos KH boc lop film.... boc lop phu, boc cac loai lop",
  timeRemaining:"22.63 hour(s) ago",
  statusTime:false,
  csState:"New",
  agent:"Caroline N",
  kindLevel1:"L300",
  kindLevel2:"L300",
  kindLevel3:"L300"
},
]


































export const dataStatusIssue = [
    {
      agent: "Celina V",
      unResolved:4,
      needResponse: 5,
      open:5,
      waitForCustomer:1,
      waitThirdParty:0,
      pending: 2,
      overdue:1,
      needResponse1:1,
      open1:1,
      unResolved1:1,
      unClosed:1
    },
    {
        agent: "Ashley",
        unResolved:2,
        needResponse: 3,
        open:3,
        waitForCustomer:2,
        waitThirdParty:1,
        pending: 1,
        overdue:3,
        needResponse1:1,
        open1:4,
        unResolved1:0,
        unClosed:0
      },
      {
        agent: "Alice P",
        unResolved:4,
        needResponse: 5,
        open:5,
        waitForCustomer:1,
        waitThirdParty:0,
        pending: 2,
        overdue:1,
        needResponse1:1,
        open1:1,
        unResolved1:1,
        unClosed:1
      },
      {
        agent: "Caroline N",
        unResolved:2,
        needResponse: 3,
        open:2,
        waitForCustomer:2,
        waitThirdParty:1,
        pending: 3,
        overdue:4,
        needResponse1:3,
        open1:3,
        unResolved1:2,
        unClosed:0
      },
]